import profile from '../assets/jpg/profile.jpg';
import contactImg from '../assets/svg/contacts/contactsBlack.svg'
import about from '../assets/svg/about/bwTheme-boy.svg';
import edu from "../assets/svg/education/eduBlack.svg"
import eduIcon from "../assets/svg/education/eduImgWhite.svg"
import exp from "../assets/svg/experience/expBlack.svg"
import expIcon from "../assets/svg/experience/expImgWhite.svg"

const bwThemeDark = {
    type: 'dark',
    primary: '#B6B6B6',
    primary400: '#B6B6B6',
    primary600: '#B6B6B6',
    primary80: '#B6B6B6cc',
    primary50: '#B6B6B680',
    primary30: '#B6B6B64d',
    secondary: '#212121',
    secondary70: '#212121b3',
    secondary50: '#21212180',
    tertiary: '#eaeaea',
    tertiary80: '#eaeaeacc',
    tertiary70: '#eaeaeab3',
    tertiary50: '#eaeaea80',
    aboutimg1: profile,
    aboutimg2: about,
    eduimg: edu,
    eduIcon: eduIcon,
    expimg: exp,
    expIcon: expIcon,
    contactsimg: contactImg
}

export default bwThemeDark;
